
import { styled } from '@core-ui/react-stitch';

interface DashboardItemProps {
  newDashboard?: boolean,
  isModelToggleEnabled?: boolean
  isBrRedesignEnabled?: boolean
}
// eslint-disable-next-line complexity
const DashboardItem = styled.div(({ newDashboard, isBrRedesignEnabled }: DashboardItemProps) => ({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  textAlign: 'center',
  flexWrap: 'wrap',
  flex: 1,
  flexDirection: 'column',
  '.filter-container': {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'flex-start',
    paddingLeft: newDashboard ? '0.5rem' : 0,
    flexDirection: 'column',
    '.filter_button': {
      padding: isBrRedesignEnabled ? '0.719rem 1rem' : 0,
    },
  },
  '&:first-of-type, &:last-child': {
    borderLeft: 'none',
    borderRight: 'none',
  },
  '&:first-of-type': {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexGrow: 1,
  },
  '&:nth-of-type(3)': {
    flexGrow: 1.3,
    padding: newDashboard ? '0.35rem 0 0.15rem' : 0,
  },
  '&:last-child': {
    alignItems: 'flex-end',
    flexGrow: 1,
    padding: newDashboard ? '0.35rem 0.5rem 0 0.15rem' : 0,
    ...newDashboard ? {
      '& .featured-indent select': {
        textAlignLast: 'unset',
        paddingRight: 'calc(50% - 2em)',
      },
    } : {},
  },
  '.all-size-indent select': {
    ...newDashboard ? {
      textAlignLast: 'unset',
      paddingLeft: 'calc(50% - 3.5em)',
    } : {},
  },
  '.value-size-indent select': {
    ...newDashboard ? {
      textAlignLast: 'unset',
      textIndent: '18%',
    } : {},
  },
}));

export default DashboardItem;
